import "core-js/modules/es.array.concat.js";
function rgba(alpha) {
  return "rgba(54, 59, 81, ".concat(alpha, ")"); // all elevation colors are based on gray05
}
export var boxShadow = {
  z1: "0px 2px 8px ".concat(rgba(0.18), ", 0px 0px 2px ").concat(rgba(0.14), ", 0px 2px 4px ").concat(rgba(0.12)),
  z2: "0px 2px 9px ".concat(rgba(0.19), ", 0px 1px 6px ").concat(rgba(0.14), ", 0px 4px 10px ").concat(rgba(0.12)),
  z3: "0px 2px 10px ".concat(rgba(0.14), ", 0px 4px 16px ").concat(rgba(0.12), ", 0px 6px 18px ").concat(rgba(0.18))
};